import { Box, Stack } from '@mui/material'
import { Suspense } from 'react'

import Header from './header'
import { Footer } from './footer'

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <Box>
      <Header />
      <Stack direction='row' height='100vh'>
        <Box
          id='main-scroll'
          component='main'
          aria-label='Main'
          width='100%'
          sx={{
            height: '100vh',
            overflowY: 'auto',
            overflowX: 'hidden',
            scrollBehavior: 'smooth'
          }}
        >
          <Suspense>{children}</Suspense>
          <Footer />
        </Box>
      </Stack>
    </Box>
  )
}
